export default "__VITE_ASSET__f6186d39__"